import GameManager from './GameManager';
import {customRouter} from '../CustomRouter'

/**
 * Describes a scenario (Base class for all scenarios)
 */
export default class Scenario {
	/**
	 * Custom properties for the scenario
	 */
	public props: any;
	
	/**
	 * ctor
	 * @param gameManager A reference to the game manager
	 * @param scenarioName The name, or id, of the scenario
	 */
	constructor(public gameManager: GameManager, public scenarioName: string) {
    	this.props = { name: scenarioName };
	}

	/**
	 * Starts the scenario
	 */
	public start(): void {
    	throw new Error('start must be implemented');
	}

	/**
	 * Starts the scenario once it can be started
	 */
	public startWhenReady(): void {
    	if(!this.gameManager || !this.gameManager.environment){
    		return;
    	}
    	if(this.gameManager.environment.isReady) {
    		this.start();
    	} else {
    		var context = this;
    		this.gameManager.environment.onReady = () => {
    			context.start();
    		};
    	}
	}

	/**
	 * Ends the scenario
	 */
	public endScenario(): void {
		var url = new URL(window.location.href);
		var search_params = url.searchParams;
		
		search_params.set('w', '0');

		url.search = search_params.toString();

		window.location.href = url.toString();
		//window.location.href = process.env.PUBLIC_URL;
	}
}